<template>
<div>
  <p v-show="false">{{Inlogged}}</p>
  <div v-if="Loaded">
   <v-card v-if="loggedInteacher==true ">  
      <v-btn @click="send=true" dark class="eraser" >
    Anmäl elevförändring
  </v-btn>

<!-- <Shower Headline="Såhär arbetar EHT"  ToolColor="amber lighten-2" /> -->
       <Formshow  Headline="Kartläggningar" :schoolId="teacher.schoolId" :id="teacher.id" ToolColor="green lighten-2" />
  <SendtoNurse :schoolId="teacher.schoolId" As="teacher"  :reporter="teacher.name"    v-model="send" />
<smalllist :person="teacher"  typ="teacher"  Headline="Ärenden"  ToolColor="deep-orange lighten-2" />
<feedback  Headline="Återkoppling"  :teacherId="teacher.id" ToolColor="purple accent-1" />
  <!-- <div v-if="APsFetched">  -->
 <AP  :schoolId="teacher.schoolId" role="teacher" :id="teacher.id"  Headline="Åtgärdsprogram" ToolColor="pink lighten-2"/>

  <!-- </div> -->
   <Course :schoolId="teacher.schoolId" :id="teacher.id" :teacher="teacher" Headline="F och varningar" ToolColor="amber lighten-2"/>
  <Extra :schoolId="teacher.schoolId"  role="teacher" :id="teacher.id"  Headline="Extraanpassningar" ToolColor="light-green lighten-3"/>
   </v-card>
  </div>
  <div v-else class="loader text-xs-center">
    <v-progress-circular
      indeterminate
      color="primary"
    ></v-progress-circular>
  </div>
</div>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import smalllist from '../components/Case/smalllist'
import feedback from '../components/Teacher/feedback'
import SendtoNurse from '../components/SendtoNurse'
import Formshow from '../components/Form/Formshow'
import Course from '../components/StudentChange/Course'
import AP from '../components/AP/AP'
import Extra from '../components/extraanpassning/extra.vue'
export default {
  components: {
    smalllist,feedback,SendtoNurse,AP,Formshow,Course,
    Extra
  },
  props: {

  },
  data: () => ({
      loaded:false,
      send:false,
      goOn: false,
  }),
  watch: {
        
  },
  computed: {
     Inlogged() {
       
      if (this.loggedInteacher && this.loaded==false) {
      let user= {uid:this.teacher.schoolId, displayName:this.teacher.name, As:"teacher"}
      this.setUser(user || null)
    this.initschool(this.teacher.schoolId)
    this.initteachers(this.teacher.schoolId)
    this.initEHT(this.teacher.schoolId)
    let data={schoolId:this.teacher.schoolId,id:this.teacher.id}
    this.initClassesforMe(data)
      this.loaded=true;
      }
      else if(this.loggedInteacher==false)
      {
        this.loaded=false;
      }
    },
    Loaded(){
      if (this.classesFetched && !this.goOn) {
        
        // let data={schoolId:this.teacher.schoolId,id:this.teacher.id}
    //     if (this.classes.length!=0) {
    //       // data.classes = this.classes
    //   // this.initcases(this.classes)

    // // this.initMappingsforMe({id:this.classes.map(CL=> CL.id)  , schoolId:this.teacher.schoolId})

    //     }
          
    // this.initAPsforMe(data)
    this.goOn=true
      }
//       else if( this.classesFetched &&this.classes.length==0)
// this.goOn=true
      if (this.teacher!= null && this.loggedInteacher&& this.goOn ) {
        return true;
      }
      return false;
    },
    ...mapGetters('teachers', ['teacher','cases', 'casesFetched', 'loggedInteacher']),
    // ...mapGetters('classesAP', ['classes','classesFetched','APs','APsFetched']),
    ...mapGetters('classesAP', ['classesFetched']),
    
    // ...mapGetters('mappings', ['Mappings']),
  },
  methods: {

    ...mapActions('schools', ['initschool']),
    ...mapActions(['setUser']),
    ...mapActions("ehtmembers", ["initEHT"]),
    ...mapActions('teachers', ['initteachers']),
    ...mapActions('classesAP', ['initClassesforMe']),

  },
  created () {
   
  },
  mounted () {

  }
}
</script>
<style>
td,
th {
  border: 1px solid #ddd;
  padding: 8px;
}
tr:hover {
  background-color: #ddd;
}
#test:nth-child(even) {
  background-color: #f2f2f2;
}

th:hover {
  background-color: #f38e4b;
}

th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #f18a45;
  color: white;
}
.loader{
  margin-top: 20vh;
}
</style>
